import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'emm-error-dialog',
    styleUrls: ['./error-dialog.component.scss'],
    templateUrl: './error-dialog.component.html'
})
export class ErrorDialogComponent implements OnInit {

    constructor(public dialogRef: MatDialogRef<ErrorDialogComponent>) {}

    ngOnInit(): void {}

    cancel(): void {
        this.dialogRef.close();
    }

    retry(): void {
        this.dialogRef.close('retry');
    }

}
